// Les deux opérations coexistent du 01/01/2027 au 31/03/2027 :
// la participation publique est sur la v4, le dépôt de tickets (et les
// formulaires liés à une participation existante) suit l'opération de
// cette participation.
export const OP_V3 = "696669f88644bf8a91004635";
export const OP_V4 = "6ab5213da6298f733bc73670";

export const CURRENT_OPERATION_ID = OP_V4;

export const FORMS_BY_OPERATION = {
  [OP_V3]: {
    CREATE: "696669f88644bf8a91004697",
    CREATE_LINE_ITEM: "696669f88644bf8a9100467b",
    MISSING: "696669f88644bf8a91004693",
    UPDATE: "696669f88644bf8a910046b0",
    QUESTIONNAIRE_HOME: "696669f88644bf8a910046a7",
    QUESTIONNAIRE_LINE_ITEM: "696669f88644bf8a9100467f",
  },
  [OP_V4]: {
    CREATE: "6ab5213ea6298f733bc736be",
    CREATE_LINE_ITEM: "6ab5213ea6298f733bc736b6",
    MISSING: "6ab5213ea6298f733bc736ba",
    UPDATE: "6ab5213ea6298f733bc736eb",
    QUESTIONNAIRE_HOME: "6ab5213ea6298f733bc736ce",
    QUESTIONNAIRE_LINE_ITEM: "6ab5213ea6298f733bc736d7",
  },
};

export function formsForOperation(operationId) {
  return FORMS_BY_OPERATION[operationId] || FORMS_BY_OPERATION[CURRENT_OPERATION_ID];
}
